/** Help menu, tour, and dev panel strings (es). */
const esHelpDev = {
  helpMenu:'Ayuda',
  helpMenuFaqs:'Preguntas frecuentes',
  helpMenuAbout:'Acerca de',
  helpMenuCharada:'Charadas',
  helpMenuTour:'Inicio rápido',
  helpMenuSupport:'Soporte',
  helpMenuChat:'Iniciar chat',
  charadaLookupTitle:'Charada',
  charadaLookupHint:'Busca por número o palabra en las tablas común, americana, china y santera.',
  charadaLookupPlaceholder:'Número o significado…',
  charadaModelComun:'Común',
  charadaModelAmericana:'Americana',
  charadaModelChina:'China',
  charadaModelSantera:'Santera',
  charadaModelAll:'Todas',
  charadaChinaHint:'La charada china (chiffa) cubre tradicionalmente del 01 al 36 (raíz de la tabla cubana).',
  aiFabHint:'Mantén pulsado para ocultar',
  helpFaqsTitle:'Preguntas frecuentes',
  helpAboutTitle:'Acerca de',
  helpAboutBody:'Alea TUI para casas de lotería — jugadas, rutas, resultados y soporte.',
  helpAboutVersion:'Versión de la app',
  helpAboutDownloads:'Descargas',
  helpAboutDownloadHint:'Instala la app Android en tu teléfono. Disponible solo si has iniciado sesión.',
  helpAboutDownloadApk:'Descargar APK Android',
  helpAboutDownloading:'Preparando descarga…',
  helpAboutDownloadUnavailable:'La descarga no está disponible ahora. Inténtalo más tarde o contacta soporte.',
  helpAboutGapi:'Ruta GAPI (soporte)',
  helpAboutApkIconHint:'Si el icono se ve genérico tras actualizar: desinstala la app, reinicia el teléfono e instala de nuevo (caché del launcher).',
  helpTourSkip:'Saltar tour',
  helpTourNext:'Siguiente',
  helpTourDone:'Listo',
  helpTourProgress:'Paso {current} de {total}',
  devPushTest:'Prueba de notificación push',
  devPushTitle:'Título',
  devPushBody:'Mensaje',
  devPushSend:'Enviar push de prueba',
  devPushSending:'Enviando…',
  devPushNoHouse:'Selecciona una casa activa (o del seed) para la prueba push.',
  devPushDefaultTitle:'Prueba push',
  devPushDefaultBody:'Mensaje de prueba desde el panel God',
  devDemoTicks:'Simulación demo en vivo',
  devDemoTicksHint:'Genera jugadas, rutas, tickets y auditoría cada 12 s (solo mock). En roles que no son lister también crea hasta 5 jugadas en vivo para el registro.',
  devDemoTicksOn:'Simulación activa',
  devDemoTicksOff:'Simulación pausada',
  devDemoRunOnce:'Ejecutar un tick ahora',
  devDemoRunning:'Ejecutando…',
  devDemoLogEmpty:'Aún no hay eventos simulados.',
  devDemoMockOnly:'Solo disponible con el adaptador mock.',
  devDemoRequiresDemoAuth:'Los ticks demo requieren auth demo en un entorno no productivo.',
  devDataLiveEmpty:'Firestore en vivo — revisa colecciones en Firebase Console. El dump del store mock está disponible con DATA_ADAPTER=mock.',
  devFirebaseDocsOnly:'Solo documentación — estos snippets no se ejecutan contra tu proyecto.',
  devSchedEmpty:'Aún no se han disparado eventos programados.',
  devNetNetwork:'Red',
  devNetServer:'Servidor',
  devNetGapi:'GAPI',
  devNetSimulated:'Simulado',
  devSimulateOffline:'Simular sin conexión',
  devSimulateOfflineHint:'Fuerza comportamiento offline (cola de escrituras, sin sync) mientras la red del dispositivo esté activa.',
  devSimulateOfflineAlreadyOffline:'El dispositivo ya está sin red. La simulación solo cambia la app cuando hay red.',
  devSimulateOfflineOn:'Sin conexión simulada activa',
  devSimulateOfflineOff:'Sin conexión simulada inactiva',
  devPanel:'Panel dev',
  maintenanceModeTitle:'Mantenimiento de plataforma',
  maintenanceModeLoginHint:'Estamos haciendo mantenimiento. Vuelve en unos minutos. Si eres operador de la plataforma, puedes iniciar sesión con normalidad.',
  appUpdateRequiredTitle:'Actualización requerida',
  appUpdateRequiredBody:'Esta versión ya no es compatible. Actualiza la app para continuar.',
  appUpdateRequiredVersions:'Instalada {current} · Requerida {min}',
  appUpdateBadge:'ACTUALIZACIÓN',
  appUpdateAvailableTitle:'Hay una actualización',
  appUpdateAvailableBody:'Hay una versión nueva disponible. Puedes actualizar ahora o más tarde.',
  appUpdateVersions:'Instalada {current} · Nueva {latest}',
  appUpdateLater:'Más tarde',
  appUpdateAction:'Actualizar',
  appUpdateUpdating:'Actualizando…',
  appUpdateDownloading:'Descargando actualización…',
  appUpdateInstalling:'Preparando instalación…',
  appUpdatePermissionNeeded:'Activa “Instalar apps desconocidas” para Alea TUI y vuelve a pulsar Actualizar.',
  appUpdateFailed:'No se pudo actualizar. Comprueba la conexión e inténtalo de nuevo.',
  featureRagDisabled:'La búsqueda en conocimiento está desactivada por configuración de plataforma.',
  featureAuditExportDisabled:'La exportación analítica está desactivada por configuración de plataforma.',
  featureLiveSupportDisabled:'El soporte en vivo está desactivado por configuración de plataforma.',
};

export default esHelpDev;
